<template>
  <Panel ref="PanelRef" :visible.sync="workOrderPopup" @close="setWorkOrderPopup(false)">
    <div class="work-order-place">
      <div class="popup-title">工单下单功能已在APP上线！</div>
      <img class="qr-code" src="https://open.591ylc.com/install/qr.png">
    </div>
  </Panel>
</template>

<script>
import Panel from './Panel.vue';
import { mapActions, mapState } from 'vuex';
export default {
  components: { Panel },
  computed: {
    ...mapState({
      workOrderPopup: state => state.comp.workOrderPopup,
    })
  },
  methods: {
    ...mapActions(['setWorkOrderPopup']),
  }
}
</script>

<style lang="less" scoped>
.work-order-place {
  width: 640px;
  height: 388px;
  background-image: url('@/assets/img/components/popup/WorkOrderPlace/background.png');
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .popup-title {
    padding-top: 56px;
    font-family: @font-medium;
    font-size: 20px;
  }
  .qr-code {
    width: 156px;
    height: 156px;
    margin-top: 58px;
  }
}
</style>
